<template>
    <div>
        <div class="row tt-item pr-lg-0">
            <div class="col-12 col-lg-4 tt-card">
                <div class="tt-title" v-if="timetable.about_link"><a :href="timetable.about_link" target="_blank">{{ timetable.name }}</a></div>
                <div class="tt-title" v-else>{{ timetable.name }}</div>
                <div class="tt-hard">
                    <img class="easy" :src="require(`@/assets/hometeacher/images/${difficlty}.png`)">
                </div>
                <div class="tt-subtitle">
                    <div class="tt-type-age">
                        <span class="tt-type" v-if="timetable.individual">{{ $t('IndividualNBSPlessons') }}</span>
                        <span class="tt-type" v-else>{{ $t('GroupNBSPlessons') }}</span>
                        <span class="tt-age"
                              v-if="timetable.min_age && timetable.max_age">
                        {{ $t('for_childs') }} {{ timetable.min_age }}-{{timetable.max_age}}&nbsp;{{ agePlural(timetable.max_age) }}
                    </span>
                    </div>
                </div>
                <div class="tt-description2">{{ timetable.description2 }}</div>
            </div>
            <div class="col-12 col-lg-4 pl-lg-0 pr-lg-0 tt-timetable-schedules">
                <TimetableSchedules :timetable="timetable" class="mt-3" @more="more"/>
            </div>
            <div class="col-12 col-lg-4 pl-lg-4">
                <SubscriptionsListCompact :timetable="timetable"
                                          :subscriptions="subscriptions"
                                          :show-back="false"
                                          :order-title="$t('sign_up')"
                                          @order="order"
                                          @bonusCourseClick="bonusCourseClick"/>
            </div>
        </div>

        <div v-if="popup" :style="popupStyle" class="tt-popup tt-popup-shadow">
            <div class="align-content-end" align="right">
                <button type="button"
                        class="close"
                        @click="popup=false"
                        data-dismiss="modal"
                        aria-label="Close">
                    <span>×</span>
                </button>
            </div>
            <div class="tt-popup-header">
                <img class="tt-popup-image" v-if="selectedCourse.logo"
                     :src="`https://www.poliglotiki.ru${selectedCourse.logo}`">
                <div class="tt-popup-title">{{ selectedCourse.name }}</div>
            </div>
            <div class="tt-popup-description"> {{ selectedCourse.description }}</div>
            <div class="tt-popup-link" v-if="selectedCourse.url">
                <a :href="`https://www.poliglotiki.ru${selectedCourse.url}`" target="_blank">{{ $t('more_about_course') }}</a>
            </div>

        </div>

    </div>
</template>

<script>


    import TimetableSchedules from "./profile/timetable/TimetableSchedules";
    import SubscriptionsListCompact from "./Subscriptions/SubscriptionsListCompact";

    export default {
        name: 'TimetableItemOT',
        props: {
            timetable: {
                type: Object,
                required: true,
            },
            subscriptions: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                prolong: false,

                popup: false,
                popupStyle: {top: 0, left: 0},

                selectedCourse: null,
            }
        },

        computed: {
          difficlty() {
            if (this.timetable && this.timetable.difficulty) {
              if (this.timetable.difficulty.toLowerCase() === 'easy' || this.timetable.difficulty.toLowerCase() === 'low') return 'easy'
              if (this.timetable.difficulty.toLowerCase() === 'medium') return 'medium'
              if (this.timetable.difficulty.toLowerCase() === 'high' || this.timetable.difficulty.toLowerCase() === 'hard') return 'high'
            }
            return 'easy';
          },
        },

        mounted() {

        },

        methods: {
            order(subscription, timetable) {
                this.$emit("order", subscription, timetable);
            },

            bonusCourseClick(subscription) {
                this.$emit("bonusCourseClick", subscription);
            },

            more(timetable) {
                this.$emit("more", timetable);
            },

            agePlural(age) {
                return this.plural([this.$t('year'), this.$t('years'), this.$t('years2')], age)
            },

            plural(forms, n) {
                let idx;
                // @see http://docs.translatehouse.org/projects/localization-guide/en/latest/l10n/pluralforms.html
                if (n % 10 === 1 && n % 100 !== 11) {
                    idx = 0; // many
                } else if (n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20)) {
                    idx = 1; // few
                } else {
                    idx = 2; // one
                }
                return forms[idx] || '';
            },

            acronym(str) {
                let data = str.split(' ')
                let output = "";
                for (var i = 0; i < 2 && i < data.length; i++) {
                    output += data[i].substring(0, 1);
                }
                if (output.length === 1) {
                    output += data[0].substring(1, 2)
                }
                return output.toUpperCase()
            },

            color(item) {
                if (item.color) return item.color
                return "hsla(" + item.id * 10 + ", 50%, 50%, 0.3)"
            },

            showPopup(course, event) {
                this.selectedCourse = course
                this.popupStyle = {top: event.layerY + 'px', left: event.layerX + 'px'}
                this.popup = true
            },
        },

        components: {
            SubscriptionsListCompact, TimetableSchedules
        }
    }
</script>

<style scoped>

    .tt-popup-link a {
        background: #bde3b5;
        color: #231c37;
        font-size: 16px;
        font-family: "Manrope Bold";
        text-align: center;
        display: block;
        width: 100%;
        border-radius: 5px;
        padding: 5px 0;
    }

    .tt-popup-description {
        line-height: 18px;
        font-size: 16px;
        color: #4f4d5c;
        clear: both;
        margin: 10px 0;
        text-align: justify;
    }

    .tt-popup-title {
        font-family: "Manrope Bold";
        font-size: 18px;
        color: #231c37;
    }

    .tt-popup-image {
        width: 85px;
        float: left;
        margin-right: 10px;
        margin-bottom: 10px;
    }

    .tt-popup-shadow {
        position: absolute;
        box-shadow: 2px 3px 11px 1px rgba(0, 0, 0, 0.2);
        background: white;
        border: 1px solid #d7e0e5;
        z-index: 1;
        border-radius: 6px;
        padding: 14px;
        max-width: 350px;
        min-width: 350px;
    }

    @media (max-width: 991.8px) {
        .tt-timetable-schedules {
            /*margin-left: -15px;
            margin-right: -15px;
            box-sizing: content-box;*/
            overflow-x: hidden;
        }

        .tt-item {
            border: none !important;
            box-shadow: 0px 6px 5px 0px #0000001c;
        }
    }

    @media (min-width: 992px) {
        .tt-timetable-schedules::before {
            content: " ";
            height: 100%;
            width: 1px;
            background: #d7e1e5;
            position: absolute;
            left: -20px;
        }

        .tt-card {
            padding-right: 50px;
        }
    }

    .tt-item {
        border: 1px solid #d7e1e5;
        border-radius: 5px;
        padding: 20px 20px;
    }

    .tt-title {
        font-size: 30px;
        line-height: 30px;
        color: #231c37;
        font-family: "Manrope Bold";
        margin-bottom: 5px;
    }

    .tt-title a{
        color: #231c37;
    }

    .tt-title a:hover{
        text-decoration: underline;
    }

    .tt-subtitle {
        font-size: 18px;
        line-height: 24px;
        color: #8b8496;
        font-family: "Manrope Bold";
        margin-top: 15px;
        margin-bottom: 20px;
    }

    .tt-description2 {
        color: #4f4d5c;
        font-size: 16px;
        line-height: 18px;
    }

    .ts-dow-name {
        font-family: "Manrope Light";
        display: inline-block;
        width: 30px;
        text-align: center;
        font-size: 12px;
        color: #4f4d5c;
        line-height: 16px;
        background: #fed7e3;
        border-radius: 10px;
        cursor: help;
    }

    .ts-dow-description {
        font-family: "Manrope Light";
        display: block;
        font-size: 15px;
        margin-left: 35px;
        line-height: 16px;
    }

    .tt-schedule {
        margin-bottom: 10px;
    }

    .ts-dow-title {
        cursor: pointer;
        margin-left: 4px;
    }

    .ts-dow-title:hover {
        text-decoration: underline;
    }

    .tt-type-age {
        font-size: 16px;
        margin-top: 20px;
    }
</style>
